var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_844_3442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4977 14.3467C15.2973 12.7822 13.7665 11.9644 12.7643 11.5733L11.1424 14.24L10.9966 12.4089L11.3793 11.5556H9.92146L10.2859 12.4089L10.1401 14.24L8.53651 11.5733C7.51602 11.9467 6.00351 12.7644 5.80305 14.3467C5.76661 14.5778 5.87595 14.7911 6.05818 14.9156C6.60487 15.2889 7.98982 16 10.6504 16C13.3109 16 14.6959 15.2889 15.2426 14.9156C15.4248 14.7911 15.5159 14.5778 15.4977 14.3467ZM13.639 14.7022H12.2176V14.3289H13.639V14.7022Z",
    fill: "#214ba5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6503 10.9868C11.9889 10.9868 13.074 9.87249 13.074 8.49792C13.074 7.12334 11.9889 6.00903 10.6503 6.00903C9.31175 6.00903 8.22664 7.12334 8.22664 8.49792C8.22664 9.87249 9.31175 10.9868 10.6503 10.9868Z",
    fill: "#214ba5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44071 12.0711H4.58196V11.4133H7.38831C7.58876 11.3067 7.78922 11.2178 7.98967 11.1289L8.62748 10.8444C7.97145 10.2756 7.57054 9.44 7.57054 8.49778C7.57054 6.79111 8.93727 5.40444 10.632 5.40444C10.9054 5.40444 11.1605 5.44 11.4156 5.51111V1.52889C11.4156 1.36889 11.2698 1.22667 11.1058 1.22667H8.37235V0.391111C8.37235 0.177778 8.19012 0 7.97145 0H3.94415C3.72548 0 3.54325 0.177778 3.54325 0.391111V1.24444H0.809792C0.645784 1.24444 0.5 1.38667 0.5 1.54667V15.1289C0.5 15.36 0.700453 15.5378 0.91913 15.5378H4.85531V12.4089H6.0398C6.18559 12.2844 6.31315 12.1778 6.44071 12.0711ZM9.5204 3.44889H10.304V5.19111H9.5204V3.44889ZM8.49991 3.44889H9.28351V5.19111H8.49991V3.44889ZM5.93047 8.81778H5.14687V7.07556H5.93047V8.81778ZM5.93047 5.20889H5.14687V3.46667H5.93047V5.20889ZM6.95096 8.81778H6.16737V7.07556H6.95096V8.81778ZM6.95096 5.20889H6.16737V3.46667H6.95096V5.20889ZM1.81206 12.7111V10.9689H2.59565V12.7111H1.81206ZM1.81206 8.81778V7.07556H2.59565V8.81778H1.81206ZM1.81206 5.20889V3.46667H2.59565V5.20889H1.81206ZM3.59792 12.7111H2.81433V10.9689H3.59792V12.7111ZM3.59792 8.81778H2.81433V7.07556H3.59792V8.81778ZM3.59792 5.20889H2.81433V3.46667H3.59792V5.20889Z",
    fill: "#214ba5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_844_3442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.d5d404b497f96273018652691bbb0ef2.svg";
export { ForwardRef as ReactComponent };